<template>
  <el-dialog
      :title="$t('autoOpenDialog.title')"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
    <p>{{$t('autoOpenDialog.content')}}</p>
    <p v-if="content1">{{$t('autoOpenDialog.content1')}}</p>
    <p v-if="content2">{{$t('autoOpenDialog.content2')}}</p>
    <span slot="footer" class="dialog-footer">
        <el-button v-if="buttonCancel" @click="dialogVisible = false">{{$t('autoOpenDialog.titleCancelledButton')}}</el-button>
        <el-button type="primary" @click="handleConfirm">{{$t('autoOpenDialog.titleConfirmButton')}}</el-button>
    </span>
    <el-checkbox v-model="checked">{{$t('autoOpenDialog.disabledMessage')}}</el-checkbox>
  </el-dialog>
</template>

<script>
export default {
  name: 'AutoOpenDialog',
  props: {
    buttonCancel: {
      type: Boolean,
      required: false
    },
    content1: {
      type: Boolean,
      required: false
    },
    content2: {
      type: Boolean,
      required: false
    },
    onConfirm: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      checked: false
    }
  },
  mounted () {
    this.dialogVisible = true
  },
  methods: {
    handleClose (done) {
      this.dialogVisible = false
    },
    handleConfirm () {
      this.onConfirm()
      this.dialogVisible = false
      this.$store.commit('setPopupStatistics', this.checked)
      this.$store.dispatch('updatedUser')
    }
  }
}
</script>
